import './style.scss';
import CodeSnippet from './codesnippet.js';

export default CodeSnippet;